'use strict';

import VZTcBaseCard from './VZTcBaseCard';

export default class VZTcActivation extends VZTcBaseCard {
    constructor() {
        super();

        this.boundHandleClick = this.handleClick.bind(this);
    }

    /**
     * @function connectedCallback
     * @description Lifecycle callback when element is added to the DOM
     */
    connectedCallback() {
        this.radio = this.querySelector('.custom-control-input');

        this.radio.addEventListener('change', this.boundHandleClick);
    }

    /**
     * @function disconnectedCallback
     * @description Removes event listeners when element is removed from the DOM
     */
    disconnectedCallback() {
        this.radio.removeEventListener('click', this.boundHandleClick);
    }

    /**
     * @function handleClick
     * @description Handles the click event on the toggle button
     * @param {Event} event - The click event
     */
    handleClick(event) {
        event.preventDefault();

        // Emit configuration update event
        if (this.radio) {
            const questionId = this.getAttribute('data-question-id');
            const productId = this.getAttribute('data-product-id');
            const answerId = Array.from(this.parentElement.querySelectorAll('.js-question-content-toggle')).findIndex((radio) => radio === event.target);
            const addToCartValues = document.querySelector('.js-add-to-cart-values');
            const usersQty = parseInt(addToCartValues?.dataset.usersqty, 10) || 1;
            const value = this.radio.checked && productId !== 'null' ? { pid: productId, qty: usersQty } : answerId.toString();

            this.updateConfig('radio', questionId, value);
        }
    }
}

if (!window.customElements.get('vz-tc-activation')) {
    window.customElements.define('vz-tc-activation', VZTcActivation);
}
